// Lasteutstyr på «Nytt oppdrag»: valgene, Tippis forslag fra lasten og visningstekst.
import { massDefaultEquipment } from './massCatalog';

export const EQUIPMENT_OPTIONS = [
  { value: 'excavator',      label: 'Gravemaskin' },
  { value: 'wheel_loader',   label: 'Hjullaster' },
  { value: 'mini_excavator', label: 'Minigraver' },
  { value: 'tractor_loader', label: 'Traktor med skuffe' },
  { value: 'other',          label: 'Annet utstyr' },
];

export const EQUIPMENT_LABELS = Object.fromEntries(EQUIPMENT_OPTIONS.map(o => [o.value, o.label]));

// Tippis forslag: bortkjøring graves opp (gravemaskin), ellers gjelder utstyrsforslaget til massetypen i massekatalogen.
export function defaultEquipment(massType, removal = false) {
  if (massType === 'other') return [];
  if (massType === 'removal' || removal) return ['excavator'];
  return massDefaultEquipment(massType);
}

// Valget følger Tippis forslag til bestilleren selv har endret det (override != null).
export function resolveEquipment({ override, massType, removal }) {
  return override ?? defaultEquipment(massType, removal);
}

// Slår et valg av/på og beholder rekkefølgen fra EQUIPMENT_OPTIONS.
export function toggleEquipment(current, value) {
  const next = current.includes(value) ? current.filter(v => v !== value) : [...current, value];
  return EQUIPMENT_OPTIONS.map(o => o.value).filter(v => next.includes(v));
}

// Navn på valgt utstyr, f.eks. «Gravemaskin, Hjullaster». Ukjente nøkler vises som de er.
export function equipmentNames(keys) {
  return (Array.isArray(keys) ? keys : []).map(k => EQUIPMENT_LABELS[k] ?? k).join(', ');
}

// «Lasteutstyr: Gravemaskin, Hjullaster», eller «Krever lasteutstyr» uten spesifikke valg (også eldre oppdrag).
export function loadingEquipmentText(order) {
  if (!order?.requiresLoadingEquipment) return null;
  const names = equipmentNames(order.loadingEquipment);
  return names ? `Lasteutstyr: ${names}` : 'Krever lasteutstyr';
}
